var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-bg-dark-teal tw-text-center tw-text-white tw-py-3 tw-z-[200] tw-text-[20px] xl:tw-text-[32px]"},[_vm._v(" New patient pricing available "),_c('strong',[_vm._v("right now")]),_vm._v(" only! ")])
}]

export { render, staticRenderFns }